import { useBlockProps, useInnerBlocksProps } from '@wordpress/block-editor';
import AllInspectorControls from './InspectorControls';

import '../style.scss';

const ALLOWED_BLOCKS = [ 'brandy/timeline-item' ];
const TEMPLATE = [
	[ 'brandy/timeline-item', {} ],
	[ 'brandy/timeline-item', {} ],
	[ 'brandy/timeline-item', {} ],
];

export default function Edit( { attributes, setAttributes } ) {
	const { layout } = attributes;

	const blockProps = useBlockProps( {
		className: `brandy-timeline brandy-timeline--${ layout }`,
		style: getEditorStyles( attributes ),
	} );

	const innerBlocksProps = useInnerBlocksProps( blockProps, {
		allowedBlocks: ALLOWED_BLOCKS,
		template: TEMPLATE,
		renderAppender: false,
	} );

	return (
		<>
			<AllInspectorControls
				attributes={ attributes }
				setAttributes={ setAttributes }
			/>
			<div { ...innerBlocksProps } />
		</>
	);
}

function getEditorStyles( attributes ) {
	return {
		'--timeline-line-color': attributes.lineColor,
		'--timeline-line-width': attributes.lineWidth + 'px',
		'--timeline-marker-size': attributes.markerSize + 'px',
		'--timeline-marker-color': attributes.markerColor,
		'--timeline-marker-bg': attributes.markerBgColor,
		'--timeline-connector-style': attributes.connectorStyle,
	};
}
